<template>
<page-content>
    <div slot="header">
        <h4 class="moduldTit">考核评分表模板</h4>
    </div>
    <div slot="content">
        <assessFormWrite :isRole="[]"></assessFormWrite>
    </div>
</page-content>
</template>
<script>
import assessFormWrite from '@/page/assessFormWrite/assessFormWrite'
import pageContent from '@/components/pageContent'
export default {
    data(){
        return {

        }
    },
    components:{
        assessFormWrite,pageContent
    }
}
</script>
